import { render, staticRenderFns } from "./feeLogBox.vue?vue&type=template&id=9a8c5372&scoped=true"
import script from "./feeLogBox.vue?vue&type=script&lang=js"
export * from "./feeLogBox.vue?vue&type=script&lang=js"
import style0 from "./feeLogBox.vue?vue&type=style&index=0&id=9a8c5372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8c5372",
  null
  
)

export default component.exports